import React from 'react';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
import { REVIEWS } from '../data/content';
import { Section, Reveal, Eyebrow } from './Section';
function ReviewCard({
  r
}: {
  r: (typeof REVIEWS)[number];
}) {
  return <div className="w-80 shrink-0 rounded-2xl border border-forest/10 bg-ivory/70 p-6" data-id="element-258" data-mp="2maxfjmx1x5dg">
      <div className="flex items-center gap-1" data-id="element-259" data-mp="2rbtf5oade5d2">
        {[...Array(r.rating)].map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-forest text-forest" data-id="element-260" data-mp="2w8toq96fhq8x" data-mpi={i} />)}
      </div>
      <p className="mt-3 text-sm leading-relaxed text-forest/75" data-id="element-261" data-mp="30aoqtfw6o7nr">“{r.text}”</p>
      <div className="mt-5 flex items-center gap-2" data-id="element-262" data-mp="352gcpd4e9p7k">
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-sage/25 font-serif text-sm text-forest" data-id="element-263" data-mp="352yjv4slhnu9">
          {r.name.charAt(0)}
        </span>
        <div data-id="element-264" data-mp="3f1ffwg6e4sn6">
          <p className="text-sm font-medium text-forest" data-id="element-265" data-mp="3f1nvwgxt8e2l">{r.name}</p>
          <p className="flex items-center gap-1 text-[11px] text-sage" data-id="element-266" data-mp="3jyxno38o91tl">
            <BadgeCheckIcon className="h-3.5 w-3.5" data-id="element-267" data-mp="2rcnq1gpysqnv" /> Verified Buyer
          </p>
        </div>
      </div>
    </div>;
}
export function Reviews() {
  const row = [...REVIEWS, ...REVIEWS];
  return <Section className="overflow-hidden py-16 md:py-20" data-id="element-268" data-mp="2hehqh5rmrwm6">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-269" data-mp="2hezuiokjbf4n">
        <Eyebrow data-id="element-270" data-mp="2ddeb0kdhw2lh">Customer Reviews</Eyebrow>
        <h2 className="mt-5 font-serif text-3xl font-medium leading-tight text-forest sm:text-4xl lg:text-[2.75rem]" data-id="element-271" data-mp="2deh2ateqc71x">
          Loved by everyday people
        </h2>
        <div className="mt-6 flex items-center justify-center gap-8" data-id="element-272" data-mp="353shvwn3cenn">
          <div data-id="element-273" data-mp="30dc42bfcyr0r">
            <p className="font-serif text-4xl text-forest" data-id="element-274" data-mp="30ctzmrijl6hr">4.9</p>
            <div className="mt-1 flex justify-center" data-id="element-275" data-mp="30b987ariy3o4">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-forest text-forest" data-id="element-276" data-mp="2w9xnnjnic8ms" data-mpi={i} />)}
            </div>
            <p className="mt-1 text-xs text-forest/60" data-id="element-277" data-mp="3o2y4t3bdpeav">Average Rating</p>
          </div>
          <span className="h-12 w-px bg-forest/15" data-id="element-278" data-mp="3o13gdf0wf421" />
          <div data-id="element-279" data-mp="1m6p80us93h3z">
            <p className="font-serif text-4xl text-forest" data-id="element-280" data-mp="1m5w6q9c29jt8">2,400+</p>
            <p className="mt-2 text-xs text-forest/60" data-id="element-281" data-mp="1r4qtfmd5fsim">Verified Reviews</p>
          </div>
        </div>
      </Reveal>

      <div className="relative mt-14" data-id="element-282" data-mp="1cet9jim95oz8">
        <div className="flex w-max gap-5 marquee-track" data-id="element-283" data-mp="1cdqgb41gjag5">
          {row.map((r, i) => <ReviewCard key={i} r={r} data-id="element-284" data-mp="1hcb8cg6k2nti" data-mpi={i} />)}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-ivory to-transparent" data-id="element-285" data-mp="13e3istbumosd" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-ivory to-transparent" data-id="element-286" data-mp="18falidz4wxs6" />
      </div>
    </Section>;
}